module.exports = __webpack_public_path__ + "static/img/cont54 (1).f41ca53.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/cont54 (1).jpg
// module id = ev1w
// module chunks = 0